import { render, staticRenderFns } from "./ReviewTasks.vue?vue&type=template&id=094522d5&"
import script from "./ReviewTasks.vue?vue&type=script&lang=js&"
export * from "./ReviewTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports